import { render, staticRenderFns } from "./goodsRecognitionRate.vue?vue&type=template&id=5e11f44a&"
import script from "./goodsRecognitionRate.vue?vue&type=script&lang=js&"
export * from "./goodsRecognitionRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports